import {createContext} from 'react';

interface CheckoutIssuingContextType {
  isCheckoutIssuing: boolean;
  setIsCheckoutIssuing: (value: boolean) => void;
}

export const CheckoutIssuingContext = createContext<CheckoutIssuingContextType | undefined>(
  undefined
);
